import { TranslateService } from '@ngx-translate/core';

export interface IOperatorRenderFunction {
  (left: string, right: any): string;
}

export interface IHumanReadableOperatorRenderFunction {
  (translate: TranslateService, left: string, right: any): string;
}

export interface IAttributeOperator {
  name: string;
  displayNameKey: string;
  humanReadableTranslationKey: string;
  renderFreeMarker: IOperatorRenderFunction;
  renderHumanReadable: IHumanReadableOperatorRenderFunction;
  doesNotRequireRightHandSide?: boolean;
}

export interface IOperatorsHash {
  [operatorName: string]: IAttributeOperator;
}

export interface ICrmEntityAttributeTypeToOperatorsHash {
  [attributeType: string]: string[];
}

export interface IBetweenValues {
  gteValue: string;
  lteValue: string;
};

export let globalHumanReadableRender = function (translate: TranslateService, left: string, right: any) {
  //use the old javascript function syntax so the 'this' will be used from the object
  //that this function is attached to. (vs typescript arrow definition that will take the this from when the
  //function is defined)
  return translate.instant(this.humanReadableTranslationKey, { leftValue: left, rightValue: right });
};

export let wrapWithProtectionCondition = function (leftHandValue: string) {
  return `((${leftHandValue})?has_content) && (${leftHandValue} != "")`;
};

export let wrapWithProtectionConditionForNegation = function (leftHandValue: string) {
  return `(!(((${leftHandValue})?has_content) && (${leftHandValue} != "")))`;
};

// The string protection does not need to check for the empty string since this could be value of the string (the empty
// string as the left value will simple fails naturally when compared to the right-hand-side value)
export let wrapWithProtectionConditionForString = function (leftHandValue: string) {
  return `(${leftHandValue})?has_content`;
};

export let wrapWithProtectionConditionForNegationString = function (leftHandValue: string) {
  return `(!((${leftHandValue})?has_content))`;
};
